import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import { Link } from 'react-router-dom';
import EventRegister, { CHANGE_LANGUAGE } from '../helper/EventRegister';
const Env = process.env;
const triamBlogs = {
    production: 'https://community.triamnetwork.com',
    staging: 'https://stg-community.triamnetwork.com'
};
class Footer extends Component {
    constructor (props) {
        super(props);
        this.state = {
            triamBlog: triamBlogs[Env.REACT_APP_ENV],
        };
    }
    onChangeLanguage = (e, lang, i18n) => {
        e.preventDefault();
        i18n.changeLanguage(lang);
        EventRegister.emit(CHANGE_LANGUAGE, { lang });
    };

    render() {
        const isDisplayOnWebview = window.location.href.endsWith('/a/faq');

        return !isDisplayOnWebview && (
            <I18n ns="translations">
                {
                    (t, {i18n}) => (
                        <footer>
                            <div className="footer-bg">
                                <div className="container">
                                    <div className="row custom-footer">
                                        <div className="col-xs-2 col-sm-2 col-md-2 wow slideInLeft footer-1 text-center">
                                            <img src="/images/logo_bottom.png" alt="TRIAM NETWORK"/>
                                            <div className="text-center">
                                                <a className={"logo-fb"} href="https://facebook.com/development.triam.3" title="https://facebook.com/development.triam.3" target={"_blank"} >
                                                    <img className={"img-logo-sn-top"} src="/images/fb-logo.png" alt="Facebook"/>
                                                </a>
                                                <a className={"logo-tw"} href="https://twitter.com/triamnetwork1" title="https://twitter.com/triamnetwork1" target={"_blank"}>
                                                    <img className={"img-logo-sn-top"} src="/images/tw-logo.png" alt="Twitter"/>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-xs-2 col-sm-2 col-md-2 footer-2">
                                            <h3 className="footer-title">{t('Home')}</h3>
                                            <p><a className="footer-link" href="https://triamnetwork.github.io/triam-docs/" target="_blank" rel="noopener noreferrer">{t('Developer')}</a></p>
                                            <p><a className="footer-link" href="https://triamnetwork.github.io/triam-sdk/" target="_blank" rel="noopener noreferrer">{t('API Document')}</a></p>
                                            <p><a className="footer-link" target="_blank" rel="noopener noreferrer" href="/documents/TRIAM.pdf">{t('White paper')}</a></p>
                                            <p><a className="footer-link" target="_blank" rel="noopener noreferrer" href="https://dashboard.triamnetwork.com/">{t('blockscan')}</a></p>
                                        </div>
                                        <div className="col-xs-2 col-sm-2 col-md-2 footer-3">
                                            <h3 className="footer-title">About</h3>
                                            <p><Link to="/faq">{t('RIA FAQ')}</Link></p>
                                            <p>
                                                <a className="footer-link" target="_blank" rel="noopener noreferrer" href={this.state.triamBlog}> {t('Community')} </a>
                                            </p>
                                        </div>
                                        {/*<div className="col-xs-2 col-sm-2 col-md-2 footer-4">*/}
                                        {/*    <h3 className="footer-title">{t('Overview')}</h3>*/}
                                        {/*</div>*/}
                                        <div className="col-xs-2 col-sm-2 col-md-2 footer-5">
                                            <h3 className="footer-title">{t('Privacy')}</h3>
                                            <p><a className="footer-link" target="_blank" rel="noopener noreferrer" href="/privacy">{t('privacy_')}</a></p>
                                        </div>
                                        <div className="col-xs-2 col-sm-2 col-md-2 footer-6">
                                            <h3 className="footer-title">{t('Language')}</h3>
                                            <p><a className="footer-link" onClick={e => this.onChangeLanguage(e, 'en', i18n)}>English</a></p>
                                            <p><a className="footer-link" onClick={e => this.onChangeLanguage(e, 'ch', i18n)}>中文(简体)</a></p>
                                            <p><a className="footer-link" onClick={e => this.onChangeLanguage(e, 'ja', i18n)}>日本語</a></p>
                                            <p><a className="footer-link" onClick={e => this.onChangeLanguage(e, 'ko', i18n)}>한국어</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    )
                }
            </I18n>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/footer.jsx